import TableCompanyRequest from '../../features/company-request/components/TableCompanyRequest/TableCompanyRequest';

const CompanyRequest = () => {
  return <TableCompanyRequest />;
};
export default CompanyRequest;
